import Vue from 'vue';
import { mapGetters } from 'vuex';
import { guid } from '@/mixins/guid';
import dropsLoader from '@/mixins/components/drops-loader';

export default Vue.component('collaborators', {
  template: require('./template.html'),
  name: 'collaborators',
  mixins: [guid],
  props: [
    'modal',
    'sub-user',
    'toggle-modal',
    'content',
  ],
  components: {
    dropsLoader,
  },
  computed: {
    ...mapGetters([
      'currentUser',
      'currentSite',
    ]),
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async addCollaborator() {
      this.loading = true;
      const notif = {
        id: this.guid(),
        type: 'success',
        message: 'Collaborator Successfully Added!',
      };
      try {
        if (!this.currentSite.collaborators) {
          this.$store.dispatch('setGlobalValue', {
            item: this.currentSite,
            key: 'collaborators',
            value: {},
          });
        }
        const { _id, sub, pic, fullname } = this.subUser;
        await this.$lightning([{
          name: 'addCollaborator',
          payload: {
            siteId: this.currentSite._id,
            subUser: { _id, sub },
          },
        }]);
        this.$store.dispatch('setGlobalValue', {
          item: this.currentSite.collaborators,
          key: _id,
          value: {
            _id,
            sub,
            pic,
            fullname,
            permissions: 'edit',
          },
        });
        this.$emit('close-collabs');
        this.closeModal('collaborators');
      } catch (e) {
        const message = e.message || e;
        this.$log.error(message);
        notif.type = 'error';
        notif.message = `${e.message || e}. This has been reported.`;
        await this._reportError({
          error: e,
          fn: 'addCollaborator',
        });
      } finally {
        this.loading = false;
        this.$store.dispatch('addNotification', notif);
      }
    },
    async removeCollaborator() {
      this.loading = true;
      const notif = {
        id: this.guid(),
        type: 'success',
        message: 'Collaborator Successfully Removed!',
      };
      try {
        const { _id, sub } = this.subUser;
        await this.$lightning([{
          name: 'removeCollaborator',
          payload: {
            siteId: this.currentSite._id,
            subUser: { _id, sub },
          },
        }]);
        const { collaborators } = this.currentSite;
        this.$store.dispatch('runStateFn', {
          fn() {
            delete collaborators[_id];
          },
        });
        this.closeModal('collaborators');
      } catch (e) {
        const message = e.message || e;
        this.$log.error(message);
        notif.type = 'error';
        notif.message = `${e.message || e}. This has been reported.`;
        await this._reportError({
          error: e,
          fn: 'removeCollaborator',
        });
      } finally {
        this.loading = false;
        this.$store.dispatch('addNotification', notif);
      }
    },
    closeModal(type) {
      this.$emit('toggle-modal', type, 'child');
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/admin/websites/edit-site/settings/collaborators/index.js